import axios from 'axios';
import { FETCH_CTV_REQUEST, FETCH_CTV_DATA, FETCH_CTV_ERROR, RESET_CTV_DATA } from './ctvTypes';
import BASE_URL from '../config';

const timeout = 120000;

function _addIds(rows) {
  return Array.isArray(rows) ? rows.map((item, idx) => ({ id: idx, ...item })) : [];
}

export const fetchCTVData = (startDate, endDate, selectedCampaigns) => (dispatch, getState) => {
  dispatch({ type: FETCH_CTV_REQUEST });

  const advertiserId = localStorage.getItem('advertiserId');
  const sfId = localStorage.getItem('sfId');
  const userEmail = getState().userReducer.userEmail;
  const campaignGuids = Array.isArray(selectedCampaigns) ? selectedCampaigns : [];

  return axios({
    method: 'post',
    url: `${BASE_URL}/getCTVData`,
    headers: { 'Content-Type': 'application/json' },
    data: {
      advertiser_id: advertiserId,
      sfId,
      startDate,
      endDate,
      userEmail,
      campaign_guids: campaignGuids
    },
    timeout
  })
    .then((response) => {
      const d = response.data || {};
      return dispatch({
        type: FETCH_CTV_DATA,
        payload: {
          overall: _addIds(d.overall),
          creative: _addIds(d.creative),
          campaign: _addIds(d.campaign),
          supply: _addIds(d.supply),
          exchange: _addIds(d.exchange)
        }
      });
    })
    .catch((error) => {
      const msg = error.response?.data?.message || 'Unable to fetch data. Please try again';
      return dispatch({ type: FETCH_CTV_ERROR, payload: msg });
    });
};

export const resetCTVData = () => ({ type: RESET_CTV_DATA });
